import { useTranslation } from 'react-i18next';

interface UserProfileProps {
    username: string;
    email: string;
}

/**
 * ユーザープロファイル表示（ユーザー名・メールは編集不可）
 */
export const UserProfile = ({ username, email }: UserProfileProps) => {
    const { t } = useTranslation('settings');
    const usernameValue = username || t('user.fields.usernamePlaceholder');

    return (
        <div className="flex flex-col gap-8">
            <div className="flex max-w-md flex-col gap-2">
                <span className="text-sm font-medium text-gray-900">{t('user.fields.username')}</span>
                <p className="text-sm text-gray-700 break-words break-all select-text">{usernameValue}</p>
            </div>
            <div className="flex max-w-md flex-col gap-2">
                <span className="text-sm font-medium text-gray-900">{t('user.fields.email')}</span>
                <p className="text-sm text-gray-700 break-words break-all select-text">
                    {email || t('user.fields.emailPlaceholder')}
                </p>
            </div>
        </div>
    );
};

export default UserProfile;
